export default ({ button }) => [
  {
    title: 'Текст', value: button.contentPosition, paramName: 'contentPosition', parentName: 'button',
  },
  {
    title: 'Иконка', value: button.iconPosition, paramName: 'iconPosition', parentName: 'button', icon: true,
  },
];
